import rill from "rill";
import getNotifications from "./notifications.controller";

const Notifications = (app) => {
  app.at(
    "/notifications/*",
    rill().setup((app) => {
      app.get("/", getNotifications);
    })
  );
};

export default Notifications;
